// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__12rHZ","alert":"SettungsInbox_alert__g3TuT"};